import React, { Component } from 'react';
import $ from 'jquery';
import { browserHistory, Link } from 'react-router';
import { ShareButtons,generateShareIcon } from 'react-share';
import { Panel } from 'react-bootstrap';
import Swiper from 'react-id-swiper';

const {FacebookShareButton,GooglePlusShareButton,TwitterShareButton} = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';
// path="/:Bname/brand-details/:DType/:Bid"

export default class About_Brand extends Component{
	constructor(props)
	{
		super(props);
		this.state={
			tot_data:[],
			products:[],
			cat:[],
			product_count:'',
			brand_details:'',
			load_more:'',
			brand_id:'',
			brand_name:'',
			type:'',
			dtype:'',
			share_msg:'',
			brand_location:'',
			logo:'',
			brand_bg:'',
			description:'',
			views_count:'',
			follow_count:'',
			brand_likes_count:'',
			deal_count:'',
			follow_status:'',
			like_status:'',
			page_loading:false,

			follow_status_flag:'',
			like_status_flag:'',
			open:false,

			brand_like_users:[],
		};
		this.getBrandDetails=this.getBrandDetails.bind(this);
		this.tokenCheck=this.tokenCheck.bind(this);
		this.likeBrand=this.likeBrand.bind(this);
		this.FollowBrand=this.FollowBrand.bind(this);
		this.ShareFunc=this.ShareFunc.bind(this);
		this.likeBrand_onload =this.likeBrand_onload.bind(this);
	}
	componentDidMount()
	{
		window.scrollTo(0, 0);				
		if(screen.width >=800)
		{
			window.location.href="/web/"+this.props.params.Bname+"/brand-details/"+this.props.params.Bid;
		}
		localStorage.removeItem('m_r_p_dt');
		// if(!localStorage.token && !localStorage.user_id)
		// {
			// localStorage.setItem('brand_details',"/"+this.props.params.Bname+'/brand-details/'+this.props.params.DType+'/'+this.props.params.Bid);
		// 	localStorage.setItem('brand_details',"/"+this.props.params.Bname+'/brand-details/'+this.props.params.Bid);
		// 	browserHistory.push('/login');
		// }
		// else
		// {
			// 


		// }
		this.getBrandDetails();
		  if(localStorage.status)
         {
         	 var status = localStorage.status;
         	this.likeBrand_onload(status);
         }
	}
	ShareFunc()
	{
		this.setState({
			open:!this.state.open,
		});
		setTimeout(() => {this.setState({open: false});}, 5000);
	}
	FollowBrand(status)
	{
		var data1={from:'mobile_web',id:localStorage.user_id,token:localStorage.token,brand_id:this.state.brand_id,status:status};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'follow_brand',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						follow_count:data.brand_follow_count,
						follow_status:data.follow_status,
					});
					if(data.follow_status===0)
					{
						this.setState({
							follow_status_flag:true,
						});
					}
					else
					{
						this.setState({
							follow_status_flag:false,
						});
					}
				}
			}.bind(this),
			error:function(err)
			{
			}
		});
	}
	likeBrand(status)
	{
		if(!localStorage.token && !localStorage.user_id)
		{
			// localStorage.setItem('brand_details',"/"+this.props.params.Bname+'/brand-details/'+this.props.params.DType+'/'+this.props.params.Bid);
			localStorage.setItem('brand_details',"/"+this.props.params.Bname+'/brand-details/'+this.props.params.Bid);
			localStorage.setItem('status',status);
			browserHistory.push('/login');
		}
		else
		{
		   if(localStorage.status)
		   {	
		      var status =localStorage.status;
     	   }
           this.likeBrand_onload(status);
        }
	}
	likeBrand_onload(status)
	{
		var data1={from:'mobile_web',id:localStorage.user_id,token:localStorage.token,brand_id:this.props.params.Bid,status:status};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'like_brand',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
				    this.setState({
						like_status:data.like_status,
						brand_likes_count:data.brand_likes_count,
						brand_like_users:data.brand_like_users,
					});
					
				}
				if(data.like_status===1)
				{
					this.setState({
						like_status_flag:true,
					});
				}
				else
				{
					this.setState({
						like_status_flag:false,
					});
				}
				this.getBrandDetails();	
				localStorage.removeItem('status');	
			}.bind(this),
			error:function(err)
			{
			}
		});
	}
	tokenCheck()
	{
		localStorage.removeItem('user_id');
		localStorage.removeItem('token');
		window.location.reload();
	}
	getBrandDetails()
	{
		this.setState({
			page_loading:true,
		});

		if(localStorage.user_id)
		{
			var uid=localStorage.user_id;
		}
		else
		{
			uid=0;
		}
		var data1={from:'mobile_web',id:uid,token:localStorage.token,brand_id:this.props.params.Bid,page:'1'};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'get_brand_details',
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						tot_data:data,
						products:data.products,
						cat:data.cat,
						product_count:data.product_count,
						brand_details:data.brand_details,
						load_more:data.load_more,
						// brand_details start 
						brand_id:data.brand_details[0].brand_id,
						brand_name:data.brand_details[0].brand_name,
						type:data.brand_details[0].type,
						dtype:data.brand_details[0].dtype,
						share_msg:data.brand_details[0].share_msg,
						brand_location:data.brand_details[0].brand_location,
						logo:data.brand_details[0].logo,
						brand_bg:data.brand_details[0].brand_bg,
						description:data.brand_details[0].description,
						views_count:data.brand_details[0].views_count,
						follow_count:data.brand_details[0].follow_count,
						brand_likes_count:data.brand_details[0].likes_count,
						deal_count:data.brand_details[0].deal_count,
						follow_status:data.brand_details[0].follow_status,
						like_status:data.brand_details[0].like_status,
						brand_like_users:data.brand_like_users,
						// brand details end
						page_loading:false,
					});
					if(data.brand_details[0].follow_status==='1')
					{
						this.setState({
							follow_status_flag:false,
						});
					}
					else
					{
						this.setState({
							follow_status_flag:true,
						});	
					}
					if(data.brand_details[0].like_status==='1')
					{
						this.setState({
							like_status_flag:true,
						});
					}
					else
					{
						this.setState({
							like_status_flag:false,
						});
					}
				}
				if(data.status==='error' && data.message==="Token mismatch")
				{
					this.tokenCheck();
				}
			}.bind(this),
			error:function(err)
			{
			}
		});
	}
	render(){
		const params = {
	      paginationClickable: true,
	      spaceBetween: 10,
	      slidesPerView: 3
	    }
		// document.title=this.state.brand_details ? 'Buy '+this.state.brand_details[0].brand_name +" Aqua Products Online | AquaDeals " : 'About the Brand | AquaDeals';
		// document.getElementsByTagName("META")[2].content ='Browse quality Aquaculture '+this.state.brand_details[0].brand_name +' feed deals from various Imported & Indian brands. Choose the best deal price from our nearest partner and avail free shipment';
		 

		 // document.getElementsByTagName("META")[2].content="Search "+this.state.brand_name+" branded quality Aquaculture " +/*data.url_dtype_name*/+" deals, choose the best deal price from our nearest partner and avail free shipment";
         document.title='Buy '+this.state.brand_name+' Aqua Products Online | AquaDeals';
	     document.getElementsByTagName("META")[2].content="Search "+this.state.brand_name+" branded quality Aquaculture deals, choose the best deal price from our nearest partner and avail free shipment";
		var cat = this.state.cat.map(function(data,index){
			var cat_count=this.state.cat.length;
			return(
				<li className={cat_count === 1 ? "abt_brnd_cat_item abt_less_items" : "abt_brnd_cat_item"}><span className="abt_bran_cat_name">{data.name}</span><span>: {data.count}</span> <i><img src={baseAssets+'images/icons2/'+data.logo} width="15px" alt=" " /></i></li>
			);
		}.bind(this));		
		var products = this.state.products.map(function(data,index){
			return(
				<div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 abt_brnd_item">
					{data.dealcount >= 2 ?
						<Link to={"/subdeals/"+data.url_dtype_name+"/"+data.url_cat_name+"/"+data.url_dtype+"/"+data.url_brand_name+"/"+data.pid} >  
					        {data.promo_ribbion ? <i className="ribbon_img"><img src={baseAssets+'images/web_imgs/'+data.promo_ribbion} alt="" /></i> : ''}
					        <div className="abt_brnd_img_blk">
					            <img src={data.image ===null ? baseAssets+'images/product_imgs/noimage1.jpg' : data.image} alt="" />
					        </div>
					        <div className="abt_brnd_data_blk">
					            {data.title ? <h5 className="abt_brnd_pro_name">{data.title}</h5> : <h5 className="abt_brnd_pro_name">&nbsp;</h5>}
					            {data.mrp ? <p className="abt_brnd_pro_price">MRP &#8377; {data.mrp}</p> : ''}
					            {data.count > 0 ? <span className="abt_brnd_views"><img src={baseAssets+'images/web_imgs/views.png'} width="17px" role="presentation"/> {data.count} {data.count >1 ? ' Views' : 'View'}</span> : ''}
					            {/*{data.dealcount >=2 ? <p className="abt_brnd_pro_price">{data.dealcount} deals available</p> : <p className="abt_brnd_pro_price">&nbsp;</p>}*/}
					        </div>
					    </Link> 
					    :
						<Link to={"/pdetails/"+data.url_dtype_name+"/"+data.url_cat_name+"/"+data.url_brand_name+"/"+data.url_product_name+"/"+data.pid+"/"+data.id}>
							{data.promo_ribbion ? <i className="ribbon_img"><img src={baseAssets+'images/web_imgs/'+data.promo_ribbion} alt="" /></i> : ''}
							<div className="abt_brnd_img_blk">
								<i><img src={data.image} alt="" /></i>
							</div>
							<div className="abt_brnd_data_blk">
								{data.title ? <h5 className="abt_brnd_pro_name">{data.title}</h5> : <h5 className="abt_brnd_pro_name">&nbsp;</h5>}
								{data.mrp ? <p className="abt_brnd_pro_price">MRP &#8377; {data.mrp}</p> : ''}
								{data.count > 0 ? <span className="abt_brnd_views"><img src={baseAssets+'images/web_imgs/views.png'} width="17px" role="presentation"/> {data.count} {data.count >1 ? 'Views' : 'View'}</span> : ''}
								{/*{data.pricediff==='' ? <p className="abt_brnd_pro_price">MRP &#8377; {data.mrp}</p> : <p className="abt_brnd_pro_price">aquacash discount &#8377; {data.pricediff}</p>}*/}
							</div>
						</Link> 
					}
				</div>
			)
		});
		// var following_btn=this.state.follow_status_flag ? <span className="pro_abt_follow_header_btn" onClick={()=>{this.FollowBrand(1)}}>Follow</span> : <span className="pro_abt_follow_header_btn_active" onClick={()=>this.FollowBrand(0)}>Following</span>;
		var likes_btn=this.state.like_status_flag ? <span className="brand_dtls_likes" onClick={()=>{this.likeBrand(0)}}><i className={"glyph_heart_active glyphicon glyphicon-heart"}></i>{this.state.brand_likes_count === '1' ? this.state.brand_likes_count+' Like' : this.state.brand_likes_count+' Likes'}</span>
									: <span className="brand_dtls_likes" onClick={()=>{this.likeBrand(1)}}><i className={"glyph_heart glyphicon glyphicon-heart"}></i>{this.state.brand_likes_count === '1' ? this.state.brand_likes_count+' Like' : this.state.brand_likes_count+' Likes'}</span>;
		var description_blk=this.state.description ? <div className="about_brand_dtls_blk">
								<h5 className="abt_brnd_h5"><span>About the brand</span><span style={{float:'right',marginRight:'5px',cursor:'pointer'}} onClick={()=>{this.ShareFunc()}}><i><img src={baseAssets+'mob-assets/share.png'} alt="share" width="19px" /></i></span></h5>
								<div>
									<Panel className="abt_brnd_panel" collapsible expanded={this.state.open}>
								        <FacebookShareButton url={'https://goo.gl/5dhJSM'} title={this.state.brand_name} description={this.state.share_msg} className="test_share1">
								            	<FacebookIcon size={32} round />
								        </FacebookShareButton>
								        <TwitterShareButton url={'https://goo.gl/5dhJSM'} title={this.state.brand_name} description={this.state.share_msg} className="test_share1">
								           	<TwitterIcon size={32} round />
								        </TwitterShareButton>
							        </Panel>
							    </div>
								<div className="abt_brnd_desc">
									<p>{this.state.description}</p>
								</div>
							</div> : '';
		var people_liked=<div className="brnd_liked_blk" >
							<h5 className="abt_brnd_h5">People who liked</h5>
							<div style={{paddingLeft:'10px',fontSize:'12px',paddingTop:'8px'}}>
								<p>Liked by {parseInt(this.state.brand_likes_count,10) === 1 ? this.state.brand_likes_count+ ' user' : this.state.brand_likes_count + ' users'}</p>
								<div className="pro_liked_profile_blk">
									{this.state.brand_like_users ? this.state.brand_like_users.map(function(data,index){
										return(
											<i className="brnd_liked_profile_icon"><img src={baseAssets+'images/pro_pics/'+data.pro_pic} alt=" " width="30px" /></i>
										)
									}) : ''}
									{parseInt(this.state.brand_like_rem_count,10 > 0) ? <span className="pro_liked_rem_count"><span>+{this.state.brand_like_rem_count}</span></span>: ''}
								</div>
							</div>
						</div>;
		return(
			<div className="mob_deals brand_dtls_page">
				{this.state.page_loading ? 
					<div className="mob_loading"><img src={baseAssets+'images/web_imgs/mob_loading.gif'} alt="Loading" /></div>
				:
				<div>
				<div className="page_hdr">
					<div className="container-fluid">
						<h5><Link onClick={()=>{browserHistory.goBack()}}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=" "/></i></Link><span className="brand_page_title">{this.state.brand_name ? this.state.brand_name : 'Brand Details'}</span></h5>
						{/*{this.state.follow_status==='1' ? <span className="pro_abt_follow_btn" onClick={()=>this.FollowBrand(0)}>Following</span> : ''}*/}
						<a href="/" className="home_logo1">
							<img src={baseAssets+'images/web_imgs/home1.png'} alt="Home" />
						</a>
						{/*{following_btn}*/}
					</div>
				</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
					<div>
						<div className="brand_dtls_blk" style={{textAlign:'center',backgroundImage:"url('https://aquadeals.in/admin/assets/images"+this.state.brand_bg+"')"}} >
							<i><img className="brand_logo_center" src={baseAssets+'images/brand_icons/'+this.state.logo} alt=" " /></i>
							<h5 className="brand_dtls_title">{this.state.brand_name ? this.state.brand_name : 'Brand Name:'}</h5>
							<div style={{marginTop:'15px'}}>
								<div className="col-sm-4 col-xs-4">
									<p style={{backgroundColor:'#fff',color:'#333',borderRadius:'20px',padding:'3px',fontSize:'11px',width:'80px'}}><i style={{marginRight:'5px'}}><img alt=" " width="17px" src={baseAssets+'images/web_imgs/views.png'} /></i>{this.state.views_count}</p>
								</div>
								<div className="col-sm-4 col-xs-4" style={{padding:'0px',textAlign:'center',marginTop:'3px',fontSize:'12px'}}>
									<a className="brand_dtls_shop_btn" href={'/pdeals/brand/'+this.state.tot_data.url_brand_name+'/'+this.props.params.Bid}>SHOP BRAND</a>
								</div>
								<div className="col-sm-4 col-xs-4" style={{paddingLeft:0}}>
									{likes_btn}
								</div>
							</div>
						</div>
						{this.state.brand_likes_count > 0 ?
							<div style={{marginTop:'-12px'}}>
								{people_liked}
							</div> : ''}
						<div style={{backgroundColor:'#f1f1f1',paddingTop:'7px'}}>
							<p className="abt_brand_p">Product Count : {this.state.product_count}</p>
							<div className="abt_brnd_cat_blk">
                          		<ul className="brand_cats_tabs">
                          			{cat}
                          		</ul>
							</div>
						</div>
						<div>
							{description_blk}
						</div>
						<h5 className="abt_brnd_h5">Products</h5>
						<div className="abt_brnd_deals_blk">
		    				{products.length > 0 ? products : ''}
		    			</div>
		    		</div>
		    	</div>
		    }
	    		
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Brands/About_Brand.js
 **/